
















import { Component, Prop, Vue } from 'vue-property-decorator'

import { ExtraData } from '../../../../../contexts'

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
@Component<OrderDetails>({
  name: 'OrderDetails'
})
export class OrderDetails extends Vue {
  @Prop({ type: Object, required: true })
  public extras!: ExtraData[]

  public get sortedExtras (): ExtraData[] {
    return [...this.extras].sort((a, b) => Number(a.index) - Number(b.index))
  }
}

export default OrderDetails

